export { default as ProductCard9 } from "./product-card";
